import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CoreUiModule, GroupTypeaheadModule } from '../../core-ui';
import { CreatePersonWithBAModule } from '../../CreatePersonWithBA';
import { TranslationsModule } from '../../translations';
import { AddToGroupPillboxModule } from '../AddToGroupPillbox/AddToGroupPillbox.module';
import { AddNewGroupComponent } from './AddNewGroup.component';
import { CreatePersonFormComponent } from './CreatePersonForm.component';
import { CreateSelfServeTeamMemberComponent } from './CreateSelfServeTeamMember.component';
import { GroupEditComponent } from './GroupEdit.component';
import { UpdateGroupComponent } from './UpdateGroup.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        CoreUiModule,
        AddToGroupPillboxModule,
        GroupTypeaheadModule,
        CreatePersonWithBAModule,
        TranslationsModule
    ],
    declarations: [
        UpdateGroupComponent,
        GroupEditComponent,
        AddNewGroupComponent,
        CreatePersonFormComponent,
        CreateSelfServeTeamMemberComponent
    ],
    exports: [
        UpdateGroupComponent,
        GroupEditComponent,
        AddNewGroupComponent,
        CreatePersonFormComponent
    ],
    providers: []
})
export class UpdateGroupModule {}
